export const DEFAULT_GIFT_WRAP_USES = 5;
